import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol viewBox=\"0 0 23 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home\"><path d=\"M2.475 11.094v9.57c0 .174.069.347.19.47a.65.65 0 0 0 .46.193h5.24v-7.026c0-.176.068-.348.19-.471a.646.646 0 0 1 .459-.195h4.475c.172 0 .338.071.46.195.121.123.19.295.19.47v7.027h5.24a.64.64 0 0 0 .46-.193.674.674 0 0 0 .19-.47v-9.582l-8.872-7.043-8.682 7.055z\" /><path d=\"M21.996 8.13L12.045.314a1.282 1.282 0 0 0-1.587 0L5.127 4.501V2.387H2.524v4.158L.508 8.129A1.347 1.347 0 0 0 .27 9.992a1.288 1.288 0 0 0 1.455.446l9.126-7.414a.475.475 0 0 1 .599-.005l9.349 7.421c.51.17 1.089.011 1.435-.448a1.346 1.346 0 0 0-.238-1.862\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/home.svg
// module id = 1551
// module chunks = 0